module.exports = __webpack_public_path__ + "img/wif.529621ac.svg";